module.exports = __webpack_public_path__ + "media/images/3dLesson-fc35451a8f998d8e0e7cb399c04279cb.svg";